import "../../App.css";
import LayerGroup from "ol/layer/Group";
import GeoJSON from "ol/format/GeoJSON";
import TileLayer from "ol/layer/Tile";
import { TileWMS } from "ol/source";
import mainWindow, { setLayersvalue } from "./../MainWindow";
import { getLayerName } from "../../TimeLine/MainTimeLineVisible";
import ImageLayer from "ol/layer/Image";
import ImageWMS from 'ol/source/ImageWMS';
import { map } from "../MainLayer";
import { weatherLayerGroup } from "../weather/weatherLayer";


export let floodLayerGroup = new LayerGroup({});

const format = new GeoJSON();

let receivedLayer: string = "";

type LayerMapType = Map<number, ImageLayer<ImageWMS>>;
let layerMap: LayerMapType = new Map();

export let floodMapGlofas: Map<string, LayerMapType> = new Map();
export let weatherMapICON: Map<string, LayerMapType> = new Map();

export function allFloodMap(weatherLayerName:string,layerMap:LayerMapType){
    floodMapGlofas.set(weatherLayerName,layerMap);
}

export function allWeatherMapICON(weatherLayerName:string,layerMap:LayerMapType){
  weatherMapICON.set(weatherLayerName,layerMap);
}

export default function addFloodLayerGroup (
    receivedWeatherLayer:  ImageLayer<ImageWMS>,
    isRemove: boolean,
    layerName: string
  ): void {
    if (!receivedWeatherLayer || !map) {
  //    console.error("Invalid layer or map reference.");
      return;
    }
  
    if (!layerName) {
   //   console.error("Layer name is required to add or remove layers.");
      return;
    }
  
    if (isRemove === false) {
      weatherLayerGroup.getLayers().clear();
      // Add the layer if it's not already present
        receivedWeatherLayer.set("name", layerName);
        map.addLayer(receivedWeatherLayer);
        getLayerName(layerName, true);
        receivedLayer = layerName;
   
    } else {
      // Remove the layer if it exists
      const layersToRemove = map
        .getLayers()
        .getArray()
        .filter((layer) => layer.get("name") === layerName);
  
      layersToRemove.forEach((layer) => {
        map.removeLayer(layer);
     //   console.log(`Layer ${layerName} removed.`);
      });
  
      if (layersToRemove.length === 0) {
      //  console.log(`No layer found with the name ${layerName}.`);
      } else {
        getLayerName(layerName, false);
      }
    }
};

export let ecmf: Map<number, number> = new Map([
  [0, 0],
  [1, 3],
  [2, 6],
  [3, 9],
  [4, 12],
  [5, 15],
  [6, 18],
  [7, 21],
  [8, 24],
  [9, 27],
  [10, 30],
  [11, 33],
  [12, 36],
  [13, 39],
  [14, 42],
  [15, 45],
  [16, 48],
  [17, 51],
  [18, 54],
  [19, 57],
  [20, 60],
  [21, 63],
  [22, 66],
  [23, 69],
  [24, 72],
  [25, 75],
  [26, 78],
  [27, 81],
  [28, 84],
  [29, 87],
  [30, 90],
  [31, 93],
  [32, 96],
  [33, 99],
  [34, 102],
  [35, 105],
  [36, 108],
  [37, 111],
  [38, 114],
  [39, 117],
  [40, 120],
  [41, 123],
  [42, 126],
  [43, 129],
  [44, 132],
  [45, 135],
  [46, 138],
  [47, 141],
  [48, 144],
  [49, 150],
  [50, 156],
  [51, 162],
  [52, 168],
  [53, 174],
  [54, 180],
  [55, 186],
  [56, 192],
  [57, 198],
  [58, 204],
  [59, 210],
  [60, 216],
  [61, 222],
  [62, 228],
  [63, 234],
  [64, 240],
]);

export let ICON: Map<number, number> = new Map([
[0, 0], [1, 1], [2, 2], [3, 3], [4, 4], [5, 5], [6, 6], [7, 7], [8, 8], [9, 9], [10, 10], [11, 11], [12, 12], [13, 13], 
[14, 14], [15, 15], [16, 16], [17, 17], [18, 18], [19, 19], [20, 20], [21, 21], [22, 22], [23, 23], [24, 24], [25, 25], 
[26, 26], [27, 27], [28, 28], [29, 29], [30, 30], [31, 31], [32, 32], [33, 33], [34, 34], [35, 35], [36, 36], [37, 37], 
[38, 38], [39, 39], [40, 40], [41, 41], [42, 42], [43, 43], [44, 44], [45, 45], [46, 46], [47, 47], [48, 48], [49, 49], 
[50, 50], [51, 51], [52, 52], [53, 53], [54, 54], [55, 55], [56, 56], [57, 57], [58, 58], [59, 59], [60, 60], [61, 61], 
[62, 62], [63, 63], [64, 64], [65, 65], [66, 66], [67, 67], [68, 68], [69, 69], [70, 70], [71, 71], [72, 72], [73, 73], 
[74, 74], [75, 75], [76, 76], [77, 77], [78, 78], [79, 79], [80, 80], [81, 81], [82, 82], [83, 83], [84, 84], [85, 85], 
[86, 86], [87, 87], [88, 88], [89, 89], [90, 90], [91, 91], [92, 92], [93, 93], [94, 94], [95, 95], [96, 96], [97, 97], 
[98, 98], [99, 99], [100, 100], [101, 101], [102, 102], [103, 103], [104, 104], [105, 105], [106, 106], [107, 107], 
[108, 108], [109, 109], [110, 110], [111, 111], [112, 112], [113, 113], [114, 114], [115, 115], [116, 116], [117, 117], 
[118, 118], [119, 119], [120, 120], [121, 121], [122, 122], [123, 123], [124, 124], [125, 125], [126, 126], [127, 127], 
[128, 128], [129, 129], [130, 130], [131, 131], [132, 132], [133, 133], [134, 134], [135, 135], [136, 136], [137, 137], 
[138, 138], [139, 139], [140, 140], [141, 141], [142, 142], [143, 143], [144, 144], [145, 145], [146, 146], [147, 147], 
[148, 148], [149, 149], [150, 150], [151, 151], [152, 152], [153, 153], [154, 154], [155, 155], [156, 156], [157, 157], 
[158, 158], [159, 159], [160, 160], [161, 161], [162, 162], [163, 163], [164, 164], [165, 165], [166, 166], [167, 167], 
[168, 168], [169, 169], [170, 170], [171, 171], [172, 172], [173, 173], [174, 174], [175, 175], [176, 176], [177, 177], 
[178, 178], [179, 179], [180, 180]]);
